import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import {Parts} from "components";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Customers_Addresses_Object} state
 *  @property {object} model
 *  @property {Customers_Addresses_Properties} model.properties
 *  @property {Customers_Addresses_Is} model.is
 *  @property {Customers_Addresses_Has} model.has
 */
class CustomerAddress extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		address: PropTypes.object,
	};

	constructor(props) {
		super(props, Types.Customers_Addresses._name);
	}

	// noinspection JSUnusedGlobalSymbols
	loadSelf = async () => {
		let data = this.props.address;

		if (!data) return;

		let newState = {
			loading: false,
			loaded: true,
		};

		if (this._ismounted) {
			this.model.properties.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.model.has.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.model.is.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.setState(newState, () => this.loadSelfAfter(data))
		}

		this.loadSelfAfterAlways();
	};

	form = () => {
		/** @type {Customers_Addresses_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Addresses_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<h4 className="section-title">Address</h4>
					<Parts.Address
						object={object}
						properties={properties}
						onTextUpdate={this.handleTextFieldPropertyUpdate}
						onSelectUpdate={this.handleSelectPropertyUpdate}
						crmAvailable={this.props.rootState && this.props.rootState.crmAvailable}
					/>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}

export default Framework.Components.withRootState(CustomerAddress);
